<template>
    <v-row>
      <v-col cols="6" class="pt-0 pb-0 mt-n0">
        <v-row>
          <v-col cols="2">
            <v-text-field class="input-text-size" label="Mtg Code"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.mtgCode" />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size" label="Servicing Company Code"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.servicingCompanyCode" />
          </v-col>
          <v-col cols="6">
            <v-checkbox v-model="editedItem.mtgServicingCompany" label="Mtg Servicing Company"
              class="input-text-size radio-and-checekbox-size" />
          </v-col>
        </v-row>
        <!-- Title companies (Tulsa: the 7000 codes) pay at closing. Their code belongs on the
             payment, so the receipt shows who paid, but the parcel's mortgage code is still the
             lender's. -->
        <v-checkbox v-model="editedItem.paidByLookupOnly" class="input-text-size
          radio-and-checekbox-size pt-0 pb-0 mt-n2"
          label="Paid By lookup only, don't assign to tax records" />
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Mailing Address 1"
        v-uppercase=globalSettingItem.conEverythingToCaps
         v-model="editedItem.addressOne" />
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Mailing Address 2"
        v-uppercase=globalSettingItem.conEverythingToCaps
         v-model="editedItem.addressTwo" />
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Mailing Address 3"
        v-uppercase=globalSettingItem.conEverythingToCaps
         v-model="editedItem.addressThree" />
        <v-row>
          <v-col cols="8">
            <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Phone Number"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.phoneNumber"/>
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Ext"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.mtgExt"/>
          </v-col>
        </v-row>
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Fax Number"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.faxNumber"/>
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Email Address"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.emailAddress"/>
        <v-row>
          <v-col class='d-flex justify-center pt-0 pb-0' cols="4">
            <span class="input-text-size mt-3">Request Method:</span>
          </v-col>
          <v-col class='d-flex justify-center pt-0 pb-0 mt-n2' cols="8">
            <v-checkbox v-model="editedItem.list" label="List"
              class="input-text-size radio-and-checekbox-size" />
            <v-checkbox v-model="editedItem.statements" label="Statements"
              class="input-text-size radio-and-checekbox-size" />
            <v-checkbox v-model="editedItem.fullTaxroll" label="Full Taxroll"
              class="input-text-size radio-and-checekbox-size" />
          </v-col>
        </v-row>
        <v-textarea class="input-text-size pt-0 pb-0 mt-n2" v-model="editedItem.notes"
        v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          outlined rows="4" label="Notes" />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n0">
        <v-text-field class="input-text-size" label="Mortgage Co Name"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.mtgCoName" />
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Contact Person 1"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.contactPersonOne" />
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Email Address"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.cpOneEmailAddress" />
        <v-row>
          <v-col cols="8">
            <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Phone Number"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.cpOnePhoneNumber" />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Ext"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.cpOneExt" />
          </v-col>
        </v-row>
        <v-textarea class="input-text-size pt-0 pb-0 mt-n2" label="Note"
        v-textAreaUppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.cpOneNote" outlined rows="2" />

        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Contact Person 2"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.contactPersonTwo" />
        <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Email Address"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.cpTwoEmailAddress" />
        <v-row>
          <v-col cols="8">
            <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Phone Number"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.cpTwoPhoneNumber" />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pt-0 pb-0 mt-n2" label="Ext"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.cpTwoExt" />
          </v-col>
        </v-row>
        <v-textarea class="input-text-size pt-0 pb-0 mt-n2" label="Note"
        v-textAreaUppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.cpTwoNote" outlined rows="2" />
      </v-col>
    </v-row>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxMortgageCodesDialog',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxMortgageCodesList',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
